/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type PreservationTierEnum = 1 | 2 | 3 | 4 | 5;

export const PreservationTierEnum = {
    NUMBER_1: 1 as PreservationTierEnum,
    NUMBER_2: 2 as PreservationTierEnum,
    NUMBER_3: 3 as PreservationTierEnum,
    NUMBER_4: 4 as PreservationTierEnum,
    NUMBER_5: 5 as PreservationTierEnum
};

